/* eslint-disable @typescript-eslint/naming-convention */
export type PickupType = 'ELocker' | 'InStore' | 'DirectToBoot' | 'DriveUp' | 'DriveThrough';

export const PickupType = {
	Locker: 'ELocker' as PickupType,
	InStore: 'InStore' as PickupType,
	DirectToBoot: 'DirectToBoot' as PickupType,
	DriveUp: 'DriveUp' as PickupType,
	DriveThrough: 'DriveThrough' as PickupType,
};
